import { STATISTIC_CENTER_OPEN } from './actionTypes'

export const openStatisticCenter = () => ({
    type: STATISTIC_CENTER_OPEN
})